<div class="form-group">
  <label *ngIf="label" class="form-label">{{ label }}</label>
  <ng-select
    bindLabel="label"
    bindValue="value"
    [ngModel]="selectedValue"
    [placeholder]="placeholder"
    [items]="users$ | async"
    [clearable]="clearable"
    [disabled]="disabled"
    [searchable]="searchable"
    (ngModelChange)="onUserChange($event)"
    (clear)="onUserClear()"
    (search)="onSearchSelect($event.term)"
    (close)="onSearchSelect()"
    (scrollToEnd)="onScrollToEndSelect()"
  >
  </ng-select>
</div>
